import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import Layout from './components/Layout.vue';
Vue.use(ElementUI);
new Vue({
  el: '#app',
  router: router,
  render: function render(h) {
    return h(Layout);
  }
});